import Component from 'gia/Component';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";

gsap.registerPlugin(ScrollTrigger);


export default class Home extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      text: [],
      line: {}
    };
  }

  mount() {
    let that = this;

    gsap.fromTo(this.ref.text, {
      scale: 0.8,
      opacity: 0
    }, {
      duration: 1,
      stagger: 0.3,
      scale: 1,
      opacity: 1
    })

    gsap.fromTo(this.ref.line, {
        x: '-400px',
      opacity:0
      }, {
        duration: 2,
      opacity:1,
        x: '0',
        ease: "bounce.out",
      delay:0.5
      }
    )

  }


}